import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "document p-4" }
const _hoisted_2 = { class: "grid p-2 mt-3" }
const _hoisted_3 = { class: "col-6 flex" }
const _hoisted_4 = { class: "col-6 flex" }
const _hoisted_5 = { class: "compass-doc-section" }
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "compass-doc-section" }
const _hoisted_8 = { class: "body" }
const _hoisted_9 = { class: "compass-doc-section" }
const _hoisted_10 = { class: "body" }
const _hoisted_11 = {
  key: 0,
  class: "grid"
}
const _hoisted_12 = { class: "col-6 pt-2" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "compass-doc-section" }
const _hoisted_16 = { class: "body" }
const _hoisted_17 = { class: "m-3" }
const _hoisted_18 = { class: "compass-doc-section p-2 mt-3" }
const _hoisted_19 = { class: "grid mt-1" }
const _hoisted_20 = { class: "grid mt-1" }
const _hoisted_21 = { class: "document-text-border col mr-3 pl-2" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "grid mt-1" }
const _hoisted_25 = { class: "document-text-border col mr-3 pl-2" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "grid mt-1" }
const _hoisted_29 = { class: "document-text-border col mr-3 pl-2" }
const _hoisted_30 = { class: "grid mt-1 align-items-center" }
const _hoisted_31 = { class: "grid mt-1" }
const _hoisted_32 = {
  class: "document-text-border col mr-3 pl-2",
  contenteditable: "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SignatureModal = _resolveComponent("SignatureModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[65] || (_cache[65] = _createElementVNode("div", { class: "compass-doc-section p-2 mt-3" }, [
        _createElementVNode("div", { class: "grid" }, [
          _createElementVNode("div", { class: "col-8 document-title" }, [
            _createElementVNode("p", null, "Application For Amendment To Compliance Schedule"),
            _createElementVNode("p", null, "Form 11 Section 106"),
            _createElementVNode("p", null, "Building Act 2004 ")
          ]),
          _createElementVNode("div", { class: "col-4 css-image compass-logo mt-2" })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("h6", null, "Project No:", -1)),
          _cache[3] || (_cache[3] = _createTextVNode(" ", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.propertyData.propertyId), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("h6", null, "C.S. No:", -1)),
          _cache[5] || (_cache[5] = _createTextVNode(" ", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.bwof.complianceSchedule), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[26] || (_cache[26] = _createElementVNode("div", { class: "header" }, [
          _createElementVNode("span", null, "BUILDING DETAILS")
        ], -1)),
        _createElementVNode("div", _hoisted_6, [
          _cache[6] || (_cache[6] = _createElementVNode("b", null, "Building name:", -1)),
          _createElementVNode("span", null, " " + _toDisplayString(_ctx.propertyData.propertyName), 1),
          _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
          _cache[8] || (_cache[8] = _createElementVNode("b", null, "Street address of building:", -1)),
          _createElementVNode("span", null, " " + _toDisplayString(_ctx.propertyData.streetAddress) + " " + _toDisplayString(_ctx.propertyData.suburb) + " " + _toDisplayString(_ctx.propertyData.city), 1),
          _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
          _cache[10] || (_cache[10] = _createElementVNode("b", null, "Legal description of land where building is located:", -1)),
          _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.legalDescription), 1),
          _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
          _cache[12] || (_cache[12] = _createElementVNode("b", null, "Location of building within site:", -1)),
          _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.locationOfBuildingWithinSite), 1),
          _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
          _cache[14] || (_cache[14] = _createElementVNode("b", null, "Current, lawfully established use:", -1)),
          _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.buildingUse), 1),
          _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
          _cache[16] || (_cache[16] = _createElementVNode("b", null, "Year first constructed:", -1)),
          _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.firstConstructed), 1),
          _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
          _cache[18] || (_cache[18] = _createElementVNode("b", null, "Intended life of the building if 50 years or less:", -1)),
          _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.intendedLifeOfTheBuilding), 1),
          _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
          _cache[20] || (_cache[20] = _createElementVNode("b", null, "Purpose group:", -1)),
          _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.purposeGroup), 1),
          _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
          _cache[22] || (_cache[22] = _createElementVNode("b", null, "Highest fire hazard category for building use:", -1)),
          _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.highestFireHazardCategoryFhcNumber), 1),
          _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
          _cache[24] || (_cache[24] = _createElementVNode("b", null, "Maximum No. of occupants:", -1)),
          _createElementVNode("span", null, " " + _toDisplayString(_ctx.bwof.maximumNumberOfOccupants), 1),
          _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[40] || (_cache[40] = _createElementVNode("div", { class: "header" }, [
          _createElementVNode("span", null, "OWNER DETAILS")
        ], -1)),
        _createElementVNode("div", _hoisted_8, [
          _cache[27] || (_cache[27] = _createElementVNode("b", null, "Name:", -1)),
          _createElementVNode("span", null, " " + _toDisplayString(_ctx.owner.companyName), 1),
          _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
          _cache[29] || (_cache[29] = _createElementVNode("b", null, "Mailing address:", -1)),
          _createElementVNode("span", null, "  " + _toDisplayString(_ctx.owner.streetAddress) + "  " + _toDisplayString(_ctx.owner.postalAddress) + "  " + _toDisplayString(_ctx.owner.suburb) + "  " + _toDisplayString(_ctx.owner.city), 1),
          _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
          _cache[31] || (_cache[31] = _createElementVNode("b", null, "Contact name:", -1)),
          _createElementVNode("span", null, " " + _toDisplayString(_ctx.contact.firstName) + " " + _toDisplayString(_ctx.contact.lastName), 1),
          _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
          _cache[33] || (_cache[33] = _createElementVNode("b", null, "Contact phone:", -1)),
          _cache[34] || (_cache[34] = _createElementVNode("span", null, " ", -1)),
          _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
          _cache[36] || (_cache[36] = _createElementVNode("b", null, "Contact mobile:", -1)),
          _createElementVNode("span", null, " " + _toDisplayString(_ctx.contact.mobile), 1),
          _cache[37] || (_cache[37] = _createElementVNode("br", null, null, -1)),
          _cache[38] || (_cache[38] = _createElementVNode("b", null, "Contact email:", -1)),
          _createElementVNode("span", null, " " + _toDisplayString(_ctx.contact.email), 1),
          _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[53] || (_cache[53] = _createElementVNode("div", { class: "header" }, [
          _createElementVNode("span", null, "AGENT DETAILS")
        ], -1)),
        _createElementVNode("div", _hoisted_10, [
          (_ctx.agent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[41] || (_cache[41] = _createElementVNode("b", null, "Name of agent:", -1)),
                  _cache[42] || (_cache[42] = _createElementVNode("span", null, " Compass New Zealand Limited", -1)),
                  _cache[43] || (_cache[43] = _createElementVNode("br", null, null, -1)),
                  _cache[44] || (_cache[44] = _createElementVNode("b", null, "Contact person:", -1)),
                  (_ctx.bwof.issuedBy == 'John')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, " John Bell"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, " Keith Flatt")),
                  _cache[45] || (_cache[45] = _createElementVNode("br", null, null, -1)),
                  _cache[46] || (_cache[46] = _createElementVNode("b", null, "Phone:", -1)),
                  _cache[47] || (_cache[47] = _createElementVNode("span", null, " 09 477 2720", -1)),
                  _cache[48] || (_cache[48] = _createElementVNode("br", null, null, -1)),
                  _cache[49] || (_cache[49] = _createElementVNode("b", null, "Relationship to owner:", -1)),
                  _cache[50] || (_cache[50] = _createElementVNode("span", null, " Owner authorised agent ", -1)),
                  _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1))
                ]),
                _cache[52] || (_cache[52] = _createElementVNode("div", { class: "col6 pt-2" }, [
                  _createElementVNode("b", null, "Mailing address:"),
                  _createElementVNode("span", null, " PO Box 303 484 North Harbour 0751"),
                  _createElementVNode("br"),
                  _createElementVNode("b", null, "Email:"),
                  _createElementVNode("span", null, " bwof@compassnzl.co.nz"),
                  _createElementVNode("br")
                ], -1))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[57] || (_cache[57] = _createElementVNode("div", { class: "header" }, [
          _createElementVNode("span", null, "APPLICATION")
        ], -1)),
        _createElementVNode("div", _hoisted_16, [
          _cache[56] || (_cache[56] = _createElementVNode("p", null, "I request that the compliance schedule for the above building be amended as follows: signify by Delete or Add.", -1)),
          _createElementVNode("div", _hoisted_17, [
            _cache[55] || (_cache[55] = _createElementVNode("div", { class: "grid" }, [
              _createElementVNode("div", { class: "col-5 doc-border" }, [
                _createElementVNode("b", null, "Specified System for amendment")
              ]),
              _createElementVNode("div", { class: "col-3 doc-border" }, [
                _createElementVNode("b", null, "Amendment")
              ]),
              _createElementVNode("div", { class: "col-4 doc-border" }, [
                _createElementVNode("b", null, "Reason")
              ])
            ], -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.textInput.length, (n, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "grid",
                key: i
              }, [...(_cache[54] || (_cache[54] = [
                _createStaticVNode("<div class=\"col-5 doc-border\"><div contenteditable=\"true\" class=\"compliance-comment p-inputtext\"></div></div><div class=\"col-3 doc-border\"><div contenteditable=\"true\" class=\"compliance-comment p-inputtext\"></div></div><div class=\"col-4 doc-border\"><div contenteditable=\"true\" class=\"compliance-comment p-inputtext\"></div></div>", 3)
              ]))]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        (_ctx.bwof.issuedBy && _ctx.bwof.issuedBy.trim())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_19, [
                _cache[58] || (_cache[58] = _createElementVNode("div", { class: "col-5 flex flex-nowrap" }, " Signature of agent on behalf of and with the authority of the owner: ", -1)),
                _createElementVNode("div", {
                  class: _normalizeClass(["document-text-border col mr-4 mt-1 css-image", [_ctx.bwof.issuedBy == 'John' ? 'signature-john':'signature-keith' ]])
                }, null, 2)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _cache[59] || (_cache[59] = _createElementVNode("div", { class: "col-1 flex flex-nowrap" }, " Name:  ", -1)),
                _createElementVNode("div", _hoisted_21, [
                  (_ctx.bwof.issuedBy == 'John')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, "John Bell"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_23, "Keith Flatt"))
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _cache[60] || (_cache[60] = _createElementVNode("div", { class: "col-1 flex flex-nowrap" }, " Position:  ", -1)),
                _createElementVNode("div", _hoisted_25, [
                  (_ctx.bwof.issuedBy == 'John')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, "General Manager (Compass New Zealand Ltd)"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_27, "Managing Director (Compass New Zealand Ltd)"))
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _cache[61] || (_cache[61] = _createElementVNode("div", { class: "col-1 flex flex-nowrap" }, " Date:  ", -1)),
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.formattedDate(_ctx.bwof.bwofIssuedDate ?? new Date())), 1)
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_30, [
                _cache[62] || (_cache[62] = _createElementVNode("div", { class: "col-2 flex" }, " Signature of owner: ", -1)),
                _createElementVNode("div", {
                  class: "document-text-border col mr-4 mt-1 css-image signature-box",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displaySignatureModal = true)),
                  style: _normalizeStyle({ backgroundImage: `url('data:image/png;base64,${_ctx.ownerSignatureBase64}')` })
                }, null, 4)
              ]),
              _cache[64] || (_cache[64] = _createElementVNode("div", { class: "grid mt-1" }, [
                _createElementVNode("div", { class: "col-2 flex flex-nowrap" }, " Name:  "),
                _createElementVNode("div", {
                  class: "document-text-border col mr-3 pl-2",
                  contenteditable: "true"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_31, [
                _cache[63] || (_cache[63] = _createElementVNode("div", { class: "col-2 flex flex-nowrap" }, " Date:  ", -1)),
                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.formattedDate(new Date())), 1)
              ])
            ], 64))
      ])
    ]),
    _createVNode(_component_SignatureModal, {
      open: _ctx.displaySignatureModal,
      signatureBase64: _ctx.ownerSignatureBase64,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.displaySignatureModal=false)),
      onUpdateSignature: _ctx.updateSignature
    }, null, 8, ["open", "signatureBase64", "onUpdateSignature"])
  ], 64))
}